import React from "react";

const BucketContext = React.createContext(null);

export default BucketContext;